import { ComparisonType, type OptionEntriesProps } from '@openx/types/targeting/targetingValuesTypes.ts';

type IsInventoryListSelectionDisabledArgs = {
  appNameEntries: OptionEntriesProps[];
  bundleIdEntries: OptionEntriesProps[];
  bundleIdComparisonType: ComparisonType;
};

export const isInventoryListSelectionDisabled = ({
  appNameEntries,
  bundleIdEntries,
  bundleIdComparisonType,
}: IsInventoryListSelectionDisabledArgs): boolean => {
  const hasAppNameBlockItems = appNameEntries.some(
    ([comparisonType, items]) => comparisonType !== ComparisonType.EQUALS && items && items.length > 0
  );
  const hasBundleIdBlockItems =
    bundleIdComparisonType !== ComparisonType.EQUALS ||
    bundleIdEntries.some(
      ([comparisonType, items]) => comparisonType !== ComparisonType.EQUALS && items && items.length > 0
    );

  return hasAppNameBlockItems || hasBundleIdBlockItems;
};
